var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"audio-icon",on:{"click":_vm.togglePlay}},[(_vm.isPlaying)?_c('img',{attrs:{"src":require("@/assets/annualReport/play.png")}}):_c('img',{attrs:{"src":require("@/assets/annualReport/pause.png")}})]),_c('audio',{ref:"audioPlayer",attrs:{"loop":"","src":require("@/assets/annualReport/morningCoffee.mp3")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }